import { Component, Input } from '@angular/core';
import { DeviceData3D, ProductionInstantData } from '../../models/device-data.model';
import { BatteryState } from '../../models/enums/battery-state.enum';
import { CommonModule } from '@angular/common';
import { BatterieIconComponent } from '../batterie-icon/batterie-icon.component';
import { EnergyInfoComponent } from '../energy-info/energy-info.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-batterie-info',
    templateUrl: './batterie-info.component.html',
    styleUrls: ['./batterie-info.component.scss'],
    imports: [CommonModule, TranslateModule, BatterieIconComponent, EnergyInfoComponent],
})
export class BatterieInfoComponent {
    @Input()
    public panel!: ProductionInstantData | DeviceData3D;

    protected batteryState = BatteryState;
}
